export const APPCONFIG = {
	MODE: import.meta.env.MODE,
	ONBOARDING_BASE_URL: window.sveaConfig.ONBOARDING_BASE_URL || "",
	BANKID_MODE: window.sveaConfig.BANKID_MODE || "",
	ENVIRONMENT_NAME: window.sveaConfig.ENVIRONMENT_NAME || "",
	RELEASE_NUMBER: window.sveaConfig.RELEASE_NUMBER || "",
	FEATURES: {
		startCompany: window.sveaConfig.FEATURE_START_COMPANY === "true",
	},
	ALERT_MESSAGE: window.sveaConfig.ALERT_MESSAGE || "",
} as const;
